import { useTranslation } from 'react-i18next';
import { SEVERITY_LABELS } from '@momentum/types';
import { ChipToggle } from '@/shared/components/ui/ChipToggle';
import { useSeverityDotColor } from '../../shared/hooks/useSeverityDotColor';

interface SeveritySelectorProps {
  value: number;
  onChange: (value: number) => void;
}

export const SeveritySelector = ({
  value,
  onChange,
}: SeveritySelectorProps) => {
  const { t } = useTranslation('knowledge');
  const getSeverityDotColor = useSeverityDotColor();

  return (
    <ChipToggle
      options={[
        {
          value: String(SEVERITY_LABELS.Low),
          label: t('severityLow'),
          icon: (
            <span
              className={`w-2 h-2 rounded-full ${getSeverityDotColor(
                SEVERITY_LABELS.Low
              )}`}
            />
          ),
        },
        {
          value: String(SEVERITY_LABELS.Medium),
          label: t('severityMedium'),
          icon: (
            <span
              className={`w-2 h-2 rounded-full ${getSeverityDotColor(
                SEVERITY_LABELS.Medium
              )}`}
            />
          ),
        },
        {
          value: String(SEVERITY_LABELS.High),
          label: t('severityHigh'),
          icon: (
            <span
              className={`w-2 h-2 rounded-full ${getSeverityDotColor(
                SEVERITY_LABELS.High
              )}`}
            />
          ),
        },
        {
          value: String(SEVERITY_LABELS.Critical),
          label: t('severityCritical'),
          icon: (
            <span
              className={`w-2 h-2 rounded-full ${getSeverityDotColor(
                SEVERITY_LABELS.Critical
              )}`}
            />
          ),
        },
      ]}
      value={String(value)}
      onChange={(severity) => onChange(Number(severity))}
    />
  );
};
